import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import './styles.css';

class BusinessPlanSectionMenuItem extends Component {
	render() {
		const { item } = this.props;
		const { label, to } = item;
		return (
			<NavLink to={to} className="business-plan-section-menu-item-layout">
				{label}
			</NavLink>
		);
	}
}

BusinessPlanSectionMenuItem.propTypes = {
	item: PropTypes.shape({
		to: PropTypes.string,
		label: PropTypes.string
	})
};

export default BusinessPlanSectionMenuItem;
